// extracted by mini-css-extract-plugin
module.exports = {"container":"GenericSummary_container__2nz42","page":"GenericSummary_page__1VHXj","section":"GenericSummary_section__-6UAr","recaptcha":"GenericSummary_recaptcha__2KCx8"};